import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-translate",
  "use": "icon-translate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-translate\"><path d=\"M64 87v850h896V87H64z m846 800H114V137h796v750zM681.3 613.7H272v-50h480v50L610.6 755.1l-35.4-35.4 106.1-106zM752 460.3H272v-50l141.4-141.4 35.4 35.4-106 106H752v50z\" fill=\"\" p-id=\"2913\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol